<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("treasury/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
  computed: {
    patientsPayment() {
          return this.$store.state.treasury.patientsPayment;
      }
  },
};
</script>